import { createAction, handleActions } from 'redux-actions'

const setEditing = createAction('SCREENS/SUB_ORDER/SET_EDITING')
const resetEditing = createAction('SCREENS/SUB_ORDER/RESET_EDITING')

const defaultState = false

const reducer = handleActions(
  {
    [setEditing]: (state, { payload }) => payload,
    [resetEditing]: () => defaultState,
  },
  defaultState,
)

export { setEditing, resetEditing, reducer }
